import axios from 'axios';
import utils from "@/common/utils";

export function downloadFile({ url: downloadUrl, docTitle }) {
  let strippedDownloadUrl = downloadUrl;
  if (downloadUrl.indexOf('&') > 0) {
    strippedDownloadUrl = downloadUrl.substring(0, downloadUrl.indexOf('&'));
  }

  console.log('DownloadFile from ', downloadUrl);
  console.log('DownloadFile from ', strippedDownloadUrl);

  // Downloading with axios makes use of the application cache in case the user is offline
  // It is not possible to use a normal <a href tag because the access to the application cache would not be possible in this case.
  axios
    .get(strippedDownloadUrl, {
      responseType: 'blob',
      timeout: 30000,
    })

    .then((resp) => resp.data)
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = docTitle;
      document.body.appendChild(a);
      a.click();
      //window.URL.revokeObjectURL(url); // makes the pdf viewer display a close button on ios
      console.log(`Das Dokument ${docTitle} wurde von ${strippedDownloadUrl} runtergeladen`); // or you know, something with better UX...
    })
    .catch((err) => console.error('error downloading document', err));
}
/**
 * Returns true if connected in any way. More reliable than window.navigator.onLine only.
 * @param Function commit - must provide the vuex commit function.
 * @returns
 */
async function isOnline({ commit }) {
    let isOnline = false;
    let offline = !window.navigator.onLine;
    if (offline) {
        console.log('isOnline? no, we are offline');
        isOnline = false;
    } else {
        //console.log('navigator.onLine=true, but we need to verify because this is not trustworthy');

        try {
            const response = await axios({ method: 'head', url: `/lifeSign`, query: { rand: utils.getRandomString() } });
            isOnline = response.status === 200;
        } catch (err) {
            isOnline = false;
        }
    }
    commit('setIsConnected', isOnline);
    return isOnline;
}
export default {
    isOnline
}
